import React from 'react';
import PropTypes from 'prop-types'
import './doxModal.scss'
import BaseModal from '../../../../../../components/library/modal/BaseModal';
import DoxModalHeader from './doxModalHeader'

const DoxModal = ({ titleKey, titleKeyParams, children, onClose, show, uploadStatus, hideCloseButton, showStatusIcon }) => {
    return (
        <BaseModal show={show} onClose={onClose} hideHeader baseClassName='dox'>
            <DoxModalHeader titleKey={titleKey} titleKeyParams={titleKeyParams} hideCloseButton={hideCloseButton} onClose={onClose} fileUploadStatus={uploadStatus} showStatusIcon={showStatusIcon} />
            <div className='dox-modal-content'>
                {children}
            </div>
        </BaseModal>
    )
}

DoxModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]).isRequired,
    titleKey: PropTypes.string.isRequired,
    titleKeyParams: PropTypes.object,
    hideCloseButton: PropTypes.bool
}

export default DoxModal;